// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 453 ? "eef9e134" : chunkId) + "." + {"125":"52d6268e5f80a6d6","260":"37b33cf94083cb38","453":"76efdbd9c98d54f6","475":"a1727776c75177ec","651":"bfec976391b60c11","766":"137b7072ba6d014a","856":"a2cc20cab435f29f"}[chunkId] + ".js";
};